export default __webpack_public_path__ + "b04a494cbaadc7fdbe8b80b0aa11f4f8.png";